import React from "react";
import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <path d="M8.77763 10.5822C8.66564 10.5737 8.5586 10.5499 8.44364 10.5499C5.98316 10.5499 3.98266 12.468 3.98266 14.825C3.98266 17.1819 5.98316 19.1 8.44364 19.1C10.7336 19.1 12.6042 17.4308 12.8541 15.3H14.8615C14.6087 18.4872 11.835 21 8.44364 21C4.88477 21 2 18.2355 2 14.825C2 11.4145 4.88477 8.64994 8.44364 8.64994C8.92443 8.64994 9.39036 8.70409 9.84042 8.79909L8.93732 10.3144L13.8955 2L21.8261 15.2991H5.96482L8.77762 10.5822L8.77763 10.5822ZM13.8955 5.82946L9.38194 13.4001H18.41L13.8955 5.82946Z" />
  </React.Fragment>,
  `Figures`
);
